function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class InteroperabilityLayer {
    refreshQueryStaleness(query, variables) {
        this.resultStore.refreshStaleness(query, variables);
    }
    constructor(resultStore){
        _define_property(this, "resultStore", void 0);
        this.resultStore = resultStore;
    }
}
export { InteroperabilityLayer as default };

//# sourceMappingURL=InteroperabilityLayer.js.map